import { API_GET_TIGERCAT_BURNS_GET_NOTES } from './constants/tigercat-operations-constants';
import {
    GET_TIGERCAT_BURNS_GET_NOTES_FAIL,
    GET_TIGERCAT_BURNS_GET_NOTES_SUCCESS
} from './types/tigercat-operations-types';

import { setAlert } from '../alert';
import api from '../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json'
    },
};

export const getNoteLogs = (carRppbProjectId, rowsPerPage, currentPage, searchQuery) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_NOTES + `/${carRppbProjectId}/${rowsPerPage}/${currentPage}?search=${searchQuery}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_NOTES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_NOTES_FAIL,
            payload: err.response.data.detail,
        });
    }
};